import React from 'react'
import {evaluation, find_evaluation} from '../../config/evaluations'

const MoreScale = () =>  {
    return <table className="more_scale">
	<tbody>
	    <tr>
		<td colSpan="4" style={{backgroundColor: find_evaluation({letter: 'D'}).color, backgroundImage: `linear-gradient(to right, ${find_evaluation({letter: 'D'}).color}, ${find_evaluation({letter: 'CCC'}).color})`}} >Risk</td>
		<td colSpan="2" style={{backgroundColor: find_evaluation({letter: 'BB'}).color, backgroundImage: `linear-gradient(to right, ${find_evaluation({letter: 'B'}).color}, ${find_evaluation({letter: 'BB'}).color})`}}>Equilibrated</td>
		<td colSpan="4" style={{backgroundColor: find_evaluation({letter: 'A'}).color, backgroundImage: `linear-gradient(to right, ${find_evaluation({letter: 'BBB'}).color}, ${find_evaluation({letter: 'AAA'}).color})`}}>Healthy</td>
	    </tr>
	    <tr>
		{evaluation.filter(e => e.letter != 'N/A').map(e => <td style={{backgroundColor: e.color}} key={e.letter}>{e.letter}</td>)}
	    </tr>
	</tbody>
    </table>
}


export default MoreScale
